import './HomePageCss/ServiceSection.css'
import AnimatedText from '../../AnimatedText';
import { Link } from 'react-router-dom';
import ServiceList from '../../DB/AllServicesList';
import { useEffect, useState } from 'react';
import { getBranchList, getPackageList } from '../../api/api';
import { capitalizeWord } from '../../utils/helper';
export default function ServiceSection() {
    const [packageList, setPackageList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchPackageListData()
        fetchBranch()
    },[])

     const fetchPackageListData = async () => {
    const payload = {
      search_key: "",
    };
    try {
      setLoading(true);
      const res = await getPackageList(payload);
      setPackageList(res?.data?.data);
    } catch (error) {
      console.error("Error fetching Package list:", error);
    } finally {
      setLoading(false);
    }
  };


  const fetchBranch  = async() => {
     try {
      setLoading(true);
      const res = await getBranchList();
      setBranchList(res?.data?.data);
    } catch (error) {
      console.error("Error fetching Branch list:", error);
    } finally {
      setLoading(false);
    }

  }

    const healthPackages = [
        'Serology',
        'RBD Healthy Life, Blood (Female)',
        'RBD Healthy Life, Blood (Male)',
        'Iron',
        'RBD Healthy Life ( Male )',
        'FSH, LH',
        'Coagulation Profile',
        'RBD Healthy Life ( Female )',
        'LH',
        'Master Health Check up',
    ];


    const locations = [
        'Lake Town',
        'Salt lake',
        'Andul',
        'Tobin Road',
        'Kankurgachi',
        'Topsia',
        'Barasat',
        'Deshpriya park',
        'Behala',
        'Contai',
        'Nepal(Kathmandu)',
    ];



    return (
        <div className="health-section">
            <div className="formalTexts">
                <AnimatedText tag="h2" type="words" y={30} className="section-title">
                    Popular Health Packages
                </AnimatedText>
                <p className="section-content">
                    {packageList.slice(0, 8).map((pkg, i) => (
                        <Link key={i} to={`/OurPackagesPage`} className="text-link">
                            {pkg?.service_name}
                            {i < packageList.length - 1 && ' | '}
                        </Link>
                    ))}
                </p>
            </div>

            <div className="formalTexts">
                <AnimatedText tag="h2" type="words" y={30} className="section-title">
                    Popular Service
                </AnimatedText>
                <p className="section-content">
                    {ServiceList.map((svs, i) => (
                        <Link key={i} to={`/service/${svs.path}`} className="text-link">
                            {svs.name}
                            {i < ServiceList.length - 1 && ' | '}
                        </Link>
                    ))}
                </p>

            </div>

            <div className="formalTexts">
                <AnimatedText tag="h2" type="chars" y={30} className="section-title">
                    Our Presence
                </AnimatedText>
                <p className="section-content">
                    {branchList.map((loc, i) => (
                        <Link key={i} 
                        // to={`/location/${loc.replace(/\s+/g, '-').toLowerCase()}`} 
                        className="text-link">
                            {capitalizeWord(loc?.center_name)}
                            {i < branchList.length - 1 && ' | '}
                        </Link>
                    ))}
                </p>
            </div>
        </div>
    );
}
